/**
 * Maps the country code 'UK' to 'GB' to comply with ISO 3166 standards,
 * as most flag libraries follow ISO 3166 conventions, which use 'GB'
 * for the United Kingdom.
 *
 * See ISO standard: https://www.iso.org/obp/ui/#iso:code:3166:GB
 *
 * @param countryCode - The country code to map (e.g., 'UK', 'FR').
 * @returns The mapped country code.
 */
export var mapCountryCode = function (countryCode) {
    return (countryCode === null || countryCode === void 0 ? void 0 : countryCode.toUpperCase()) === 'UK' ? 'GB' : countryCode === null || countryCode === void 0 ? void 0 : countryCode.toUpperCase();
};
export default {};
